import { __extends } from "tslib";
import { DDBase } from './ddbase';
var Entity = /** @class */ (function (_super) {
    __extends(Entity, _super);
    function Entity(tId) {
        var _this = _super.call(this) || this;
        _this.id = tId;
        return _this;
    }
    Entity.prototype.initWithJsonObj = function (jsonObj) {
        this.jsonObj2Class(jsonObj);
    };
    Entity.prototype.jsonObj = function () {
        return this.class2JsonObj();
    };
    Entity.prototype.getIdentity = function () {
        return this.id;
    };
    /**
     * 对于实体来说，要么两个instance是一个对象，或者ID相同，即作为是相同的
     * @param other 要比较的对象
     * @returns 是否相等
     */
    Entity.prototype.equals = function (other) {
        // 校验上层JS代码或命令行等调用equals不传参数
        if (other === null) {
            return false;
        }
        if (this === other) {
            return true;
        }
        return this.getIdentity() === other.getIdentity();
    };
    return Entity;
}(DDBase));
export { Entity };
